import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-privacy-policy',
  standalone: true,
  imports: [CommonModule], 
  templateUrl: './privacy-policy.component.html',
  styleUrl: './privacy-policy.component.scss'
})
export class PrivacyPolicyComponent {
  tocItems = [
    { id: 'section1', title: '1. Information We Collect' },
    { id: 'section2', title: '2. How We Use Your Information' },
    { id: 'section3', title: '3. How We Share Your Information' },
    { id: 'section4', title: '4. Data Security' },
    { id: 'section5', title: '5. Your Rights' },
    { id: 'section6', title: '6. Data Retention' },
    { id: 'section7', title: '7. Third-Party Links' },
    { id: 'section8', title: '8. International Data Transfers' },
    { id: 'section9', title: '9. Changes to This Privacy Policy' },
    { id: 'section10', title: '10. Contact Us' },
  ];

  scrollTo(id: string) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
